// Auth Action Type Code Here


export const AUTH_LOGIN = "auth/login";
export const AUTH_LOGOUT = "auth/logout";
export const AUTH_SIGN_UP = "auth/signup";
